import { Localizable } from '@components/localizable/Localizable'
import { FormQuestion as FormQuestionModel } from '@models/membership/Form'
import { useAppSelector } from '@store/hooks'
import { selectFormQuestionOptionsByIds } from '@store/membership/FormQuestionOptionReducer'
import { selectFormQuestionById } from '@store/membership/FormQuestionReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Flex, Space, Tag, Typography } from 'antd'
import { FC } from 'react'

const { Text } = Typography

type Props = SBModelComponent<FormQuestionModel> & {}

const FormQuestionAvatar: FC<Props> = ({ id, model }) => {
  const item = model ?? useAppSelector(selectFormQuestionById(id!))
  const options = useAppSelector(
    selectFormQuestionOptionsByIds(item?.options || [])
  )

  if (!item) {
    return <></>
  }

  return (
    <Space>
      <Flex vertical gap={20}>
        <Localizable.Render
          item={item}
          render={(localizedItem, lang) => (
            <Space orientation="vertical">
              <Text>
                {lang.flag}{' '}
                <span
                  dangerouslySetInnerHTML={{ __html: localizedItem.title }}
                />
              </Text>
              {options.length > 0 && (
                <Space wrap>
                  {options.map((option) => (
                    <Tag key={option.id}>{option[lang.code].label}</Tag>
                  ))}
                </Space>
              )}
            </Space>
          )}
        />
      </Flex>
    </Space>
  )
}

type FormQuestionAvatarType = { Avatar: typeof FormQuestionAvatar }

export { FormQuestionAvatar, type FormQuestionAvatarType }
